/**
 * Credit Adjustment Modal Controller
 *
 * Manages the superadmin credit adjustment modal
 * @module portal/modules/ui/modals/creditModal
 */

import { getSelectedUserData } from '../../superadmin';
import { els } from '../elements';
import { showToast } from '../toasts';

const bodyEl = document.body;

/**
 * Open the credit adjustment modal for the currently selected user
 */
export function openCreditAdjustmentModal(): void {
  const userData = getSelectedUserData();
  if (!userData) {
    showToast('Please select a user first.', {
      type: 'warning',
    });
    return;
  }

  if (els.creditAdjustmentUserName) {
    const displayName =
      userData.displayName ||
      userData.company ||
      userData.name ||
      userData.email ||
      userData.userId ||
      'Unknown User';
    els.creditAdjustmentUserName.textContent = displayName;
  }

  if (els.creditAdjustmentCurrentBalance) {
    const credits =
      typeof (userData as any).creditsRemaining === 'number'
        ? (userData as any).creditsRemaining
        : 0;
    const ledger = ((userData as any).creditLedger || {}) as {
      grantedTotal?: number;
      consumedTotal?: number;
    };
    const granted = ledger?.grantedTotal ?? 0;
    const consumed = ledger?.consumedTotal ?? 0;
    const hasLedgerData = ledger && (granted > 0 || consumed > 0);
    const balanceText = hasLedgerData
      ? `Current balance: ${credits} credits (Granted: ${granted}, Consumed: ${consumed})`
      : `Current balance: ${credits} credits`;
    els.creditAdjustmentCurrentBalance.textContent = balanceText;
  }

  if (els.creditAdjustmentForm) {
    (els.creditAdjustmentForm as HTMLFormElement).reset();
  }
  if (els.creditNoteCharCount) {
    els.creditNoteCharCount.textContent = '0';
  }

  if (els.creditAdjustmentModalBackdrop) {
    els.creditAdjustmentModalBackdrop.hidden = false;
  }
  if (els.creditAdjustmentModal) {
    els.creditAdjustmentModal.hidden = false;
  }
  if (bodyEl) {
    bodyEl.classList.add('modal-open');
  }

  if (els.creditDelta) {
    window.requestAnimationFrame(() => {
      (els.creditDelta as HTMLElement).focus();
    });
  }
}

/**
 * Close the credit adjustment modal
 */
export function closeCreditAdjustmentModal(): void {
  if (els.creditAdjustmentModal) {
    els.creditAdjustmentModal.hidden = true;
  }
  if (els.creditAdjustmentModalBackdrop) {
    els.creditAdjustmentModalBackdrop.hidden = true;
  }
  if (bodyEl) {
    bodyEl.classList.remove('modal-open');
  }
}
